/* eslint-disable */
// COPIA de backend/utils/matchEngine.js (ESM). Re-copiar si cambia el backend.
// Motor de simulación de resultados para el modo carrera.
import i18n from './i18n';

function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Algoritmo de Knuth para muestrear de una distribución de Poisson.
function poissonSample(lambda) {
    const L = Math.exp(-lambda);
    let k = 0;
    let p = 1;
    do {
        k++;
        p *= Math.random();
    } while (p > L);
    return k - 1;
}

// Probabilidad de que el jugador participe en un gol de su equipo, según su posición (nuevas
// 6 posiciones). Calibrado para que un crack no pase de ~0.7 goles/partido.
const PARTICIPACION = {
    'Delantero Centro':        { gol: 0.32, asistencia: 0.10 },
    'Delantero Extremo':       { gol: 0.18, asistencia: 0.20 },
    'Mediocampista Ofensivo':  { gol: 0.11, asistencia: 0.20 },
    'Mediocampista Defensivo': { gol: 0.05, asistencia: 0.11 },
    'Defensor Lateral':        { gol: 0.03, asistencia: 0.10 },
    'Defensor Central':        { gol: 0.02, asistencia: 0.04 },
};

// Categoría de la posición (para repartir el aporte del jugador entre ataque y defensa).
function categoriaPosicion(posicion) {
    if (posicion === 'Delantero Extremo' || posicion === 'Delantero Centro') return 'atacante';
    if (posicion === 'Mediocampista Ofensivo' || posicion === 'Mediocampista Defensivo') return 'mediocampista';
    return 'defensivo';
}

// ── Plan de partido (lo elegís vos, como una charla táctica con el DT) ──
// A diferencia de un "foco" individual, el plan mueve el rendimiento de TODO el equipo: el
// esperado de goles propio (own) y el del rival (riv). Su efectividad depende del rival, tipo
// piedra-papel-tijera con las estrellas: el plan correcto para ese rival da un plus y el
// equivocado un castigo, así el usuario siente que incide en el RESULTADO y no solo en su
// rendimiento. "var" modula la varianza del partido (posesión = menos sorpresas) y gol/amarilla/
// roja siguen modulando el aporte/riesgo individual del jugador.
const PLANES = ['equilibrado', 'presion', 'contra', 'posesion'];

// Compatibilidad con carreras viejas que guardaban "mentalidades" en el mismo campo.
const LEGACY_PLAN = { normal: 'equilibrado', ataque: 'presion', tranquilo: 'contra', choque: 'posesion' };
function normPlan(p) { return PLANES.includes(p) ? p : (LEGACY_PLAN[p] || 'equilibrado'); }

const PLAN_MODS = {
    //            own   riv   var   gol   amarilla roja
    equilibrado: { own: 1.00, riv: 1.00, var: 1.00, gol: 1.00, amarilla: 1.0, roja: 1.0 },
    presion:     { own: 1.18, riv: 1.12, var: 1.12, gol: 1.25, amarilla: 1.2, roja: 1.4 },
    contra:      { own: 0.86, riv: 0.80, var: 0.92, gol: 0.95, amarilla: 1.0, roja: 0.85 },
    posesion:    { own: 1.06, riv: 0.90, var: 0.80, gol: 1.00, amarilla: 0.9, roja: 0.8 },
};
const planMods = (p) => PLAN_MODS[normPlan(p)];

// Qué tan bien le viene el plan a ESTE rival, según la diferencia de estrellas (propias - rival).
// Devuelve -1..1: +1 = plan ideal para ese rival, -1 = plan equivocado.
function planMatchup(plan, diff) {
    const d = clamp(diff, -2, 2);
    const p = normPlan(plan);
    if (p === 'presion') return d / 2;                       // ideal vs más débiles, malo vs más fuertes
    if (p === 'contra') return -d / 2;                       // ideal vs más fuertes, flojo vs más débiles
    if (p === 'posesion') return clamp(d / 1.5, -1, 1) * 0.6; // leve, mejor si sos favorito
    return 0;
}

// Texto corto que explica si el plan le vino bien al rival y cómo salió (feedback al usuario).
function planFeedback(plan, diff, gf, gc) {
    const p = normPlan(plan);
    if (p === 'equilibrado') return null;
    const acierto = planMatchup(p, diff);
    const gano = gf > gc, empato = gf === gc;
    const bien = acierto >= 0.34, mal = acierto <= -0.34;
    if (p === 'presion') {
        if (bien) return gano ? '⚔️ Presión alta letal: los ahogaste arriba y los liquidaste.' : '⚔️ Presionaste bien arriba, faltó la puntería.';
        if (mal) return gano ? '😅 Arriesgaste yendo al frente ante un rival fuerte y salió bien.' : '⚠️ Fuiste al frente y te agarraron mal parado de contra.';
        return gano ? '⚔️ Fuiste al frente y se te dio.' : '⚔️ Fuiste al frente pero no alcanzó.';
    }
    if (p === 'contra') {
        if (bien) return (gano || empato) ? '🛡️ Te replegaste y los lastimaste de contra.' : '🛡️ Aguantaste bien atrás, pero te terminaron encontrando.';
        if (mal) return gano ? '🛡️ Especulaste de más, igual lo sacaste adelante.' : '🐢 Se metieron atrás y no los pudiste romper.';
        return gano ? '🛡️ Orden atrás y contra letal.' : '🛡️ Te replegaste y no te alcanzó.';
    }
    if (p === 'posesion') {
        if (acierto > 0) return gano ? '🎯 Controlaste el partido de punta a punta.' : '🎯 Tuviste la pelota pero no la metiste.';
        return gano ? '🎯 Manejaste los tiempos y se te dio.' : '🎯 Mucha posesión, poca profundidad.';
    }
    return null;
}

// ════════════════════════════════════════════════════════════════════════════
//  Pizarra táctica (5 ejes) — la "intervención" del usuario como DT
// ════════════════════════════════════════════════════════════════════════════
// Elegís 5 variables que se combinan; cada una aporta a tres escalares del equipo: ataque (atk),
// solidez defensiva (def) y riesgo (exposición a la contra + varianza). Además estilo/presión/
// marca definen CRUCES (contras) con el esquema del rival: leer al rival y combinar bien tu
// pizarra es lo que termina inclinando el partido. El rival arma su propia pizarra de forma
// determinista (según sus estrellas), así el "scouting" que ve el usuario coincide con la realidad.

const FORMACIONES = ['5-4-1', '4-4-2', '4-3-3', '3-4-3'];
const ACTITUDES = ['defensiva', 'equilibrada', 'ofensiva', 'todo_o_nada'];
const PRESIONES = ['repliegue', 'media', 'alta'];
const ESTILOS = ['posesion', 'directo', 'bandas', 'contra'];
const MARCAS = ['zona', 'hombre'];

const EJE_FORMACION = {
    '5-4-1': { atk: -2.5, def: 2.5, riesgo: -1.0 },
    '4-4-2': { atk: 0.0, def: 0.0, riesgo: 0.0 },
    '4-3-3': { atk: 1.5, def: -1.0, riesgo: 1.0 },
    '3-4-3': { atk: 3.0, def: -2.5, riesgo: 2.0 },
};
const EJE_ACTITUD = {
    defensiva:   { atk: -1.5, def: 1.5, riesgo: -0.5 },
    equilibrada: { atk: 0.0, def: 0.0, riesgo: 0.0 },
    ofensiva:    { atk: 1.5, def: -1.0, riesgo: 0.5 },
    todo_o_nada: { atk: 3.0, def: -2.0, riesgo: 1.5 },
};
const EJE_PRESION = {
    repliegue: { atk: -0.5, def: 1.5, riesgo: -1.0 },
    media:     { atk: 0.0, def: 0.0, riesgo: 0.0 },
    alta:      { atk: 1.0, def: 0.5, riesgo: 1.5 },
};
const EJE_ESTILO_ATK = { posesion: 0.5, directo: 1.0, bandas: 0.8, contra: -0.5 };
const EJE_MARCA = {
    zona:   { def: 0.5, riesgo: 0.0 },
    hombre: { def: 1.0, riesgo: 0.5 },
};

function defaultTacticas() {
    return { formacion: '4-4-2', actitud: 'equilibrada', presion: 'media', estilo: 'posesion', marca: 'zona' };
}

// Normaliza una pizarra (rellena valores faltantes/ inválidos con el default).
function normTacticas(t) {
    const d = defaultTacticas();
    if (!t) return d;
    return {
        formacion: FORMACIONES.includes(t.formacion) ? t.formacion : d.formacion,
        actitud: ACTITUDES.includes(t.actitud) ? t.actitud : d.actitud,
        presion: PRESIONES.includes(t.presion) ? t.presion : d.presion,
        estilo: ESTILOS.includes(t.estilo) ? t.estilo : d.estilo,
        marca: MARCAS.includes(t.marca) ? t.marca : d.marca,
    };
}

// Escalares de equipo (atk/def/riesgo) + coherencia interna a partir de la pizarra.
function tacticaScalars(t) {
    const tt = normTacticas(t);
    const F = EJE_FORMACION[tt.formacion], A = EJE_ACTITUD[tt.actitud], P = EJE_PRESION[tt.presion], M = EJE_MARCA[tt.marca];
    let atk = F.atk + A.atk + P.atk + (EJE_ESTILO_ATK[tt.estilo] || 0);
    let def = F.def + A.def + P.def + M.def;
    let riesgo = F.riesgo + A.riesgo + P.riesgo + M.riesgo + (tt.estilo === 'contra' ? -1 : tt.estilo === 'directo' ? 0.5 : 0);

    // Coherencia interna: qué tan alineadas están formación / actitud / presión en la misma
    // dirección (todo ofensivo o todo defensivo = coherente; mezcla contradictoria = confuso).
    const o = [F.atk, A.atk, P.atk];
    const mean = (o[0] + o[1] + o[2]) / 3;
    const varz = (Math.pow(o[0] - mean, 2) + Math.pow(o[1] - mean, 2) + Math.pow(o[2] - mean, 2)) / 3;
    const coherencia = clamp(1 - Math.sqrt(varz) / 3.2, 0.55, 1); // 1 = coherente, ~0.55 = caótico

    // La confusión te resta efectividad (atacás/defendés peor) y te suma riesgo.
    atk *= coherencia;
    def *= coherencia;
    riesgo *= (2 - coherencia);
    return { atk, def, riesgo, coherencia, ...tt };
}

// Cruce de estilos (contras): cuánto le saca MI esquema al esquema rival. Devuelve un escalar
// (puede ser negativo si el rival me contraresta). Es la lectura piedra-papel-tijera.
function cruceTactico(mis, riv, misSc, rivSc) {
    let s = 0;
    if (mis.presion === 'alta') {
        if (riv.estilo === 'posesion') s += 0.6;
        if (riv.estilo === 'directo' || riv.estilo === 'contra') s -= 0.55;
    }
    if (mis.presion === 'repliegue') {
        if (riv.estilo === 'directo') s += 0.4;
        if (riv.estilo === 'posesion') s -= 0.35;
    }
    if (mis.estilo === 'directo' && riv.presion === 'alta') s += 0.5;
    if (mis.estilo === 'posesion' && riv.presion === 'alta') s -= 0.5;
    if (mis.estilo === 'contra' && rivSc.atk > 1.5) s += 0.6;
    if (mis.estilo === 'contra' && rivSc.atk < 0) s -= 0.3;
    if (mis.estilo === 'bandas' && riv.marca === 'hombre') s += 0.4;
    if (mis.estilo === 'posesion' && riv.marca === 'hombre') s -= 0.3;
    if (misSc.riesgo > 2.5 && (riv.estilo === 'contra' || riv.estilo === 'directo')) s -= 0.4;
    return clamp(s, -1.3, 1.3);
}

// Evalúa MI pizarra contra la del rival (+ diff de estrellas) y devuelve los multiplicadores que
// se aplican al esperado de goles propio y rival, la varianza, y los mods de aporte individual.
function evaluarTactica(misTacticas, rivalTacticas, diffEstrellas = 0) {
    const mis = normTacticas(misTacticas);
    const riv = normTacticas(rivalTacticas);
    const misSc = tacticaScalars(mis);
    const rivSc = tacticaScalars(riv);

    const miCruce = cruceTactico(mis, riv, misSc, rivSc);
    const suCruce = cruceTactico(riv, mis, rivSc, misSc);
    const acierto = clamp(miCruce - 0.5 * suCruce, -1.3, 1.3);

    const ownMul = clamp(1 + 0.05 * misSc.atk + 0.12 * acierto, 0.6, 1.7);
    const rivCounter = (riv.estilo === 'contra' || riv.estilo === 'directo') ? 1 : 0.4;
    const rivMul = clamp(
        1 - 0.045 * misSc.def + 0.10 * suCruce + 0.035 * Math.max(0, misSc.riesgo) * rivCounter,
        0.55, 1.8
    );

    const varianza = clamp(1 + 0.05 * misSc.riesgo - (mis.estilo === 'posesion' ? 0.15 : 0), 0.7, 1.45);

    const gol = clamp(1 + 0.07 * misSc.atk, 0.75, 1.35);
    const amarilla = clamp(1 + 0.10 * Math.max(0, misSc.riesgo) + (mis.marca === 'hombre' ? 0.2 : 0), 0.8, 1.9);
    const roja = clamp(1 + 0.12 * Math.max(0, misSc.riesgo), 0.8, 1.8);

    return { ownMul, rivMul, varianza, gol, amarilla, roja, acierto, coherencia: misSc.coherencia, misSc, rivSc };
}

// Hash determinista (FNV-1a) para que el rival arme SIEMPRE la misma pizarra ante el mismo partido.
function hashStr(s) {
    let h = 2166136261;
    for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
}

// Pizarra del rival, determinista a partir de una "key" (temporada-jornada-rival) y sus estrellas.
function rivalTacticas(rivalClub, key) {
    const est = rivalClub?.estrellas || 3;
    const h = hashStr(String(key) + ':' + (rivalClub?.tm_id || 0));
    const bit = (n) => (h >> (n * 3)) & 7;
    const ofensivo = est >= 4, defensivo = est <= 2;
    const formacion = ofensivo
        ? ['4-3-3', '3-4-3', '4-4-2', '4-3-3'][bit(0) % 4]
        : defensivo
            ? ['5-4-1', '4-4-2', '5-4-1', '4-4-2'][bit(0) % 4]
            : FORMACIONES[bit(0) % 4];
    const actitud = ofensivo
        ? ['ofensiva', 'equilibrada', 'ofensiva', 'todo_o_nada'][bit(1) % 4]
        : defensivo
            ? ['defensiva', 'equilibrada', 'defensiva', 'defensiva'][bit(1) % 4]
            : ACTITUDES[bit(1) % 4];
    const presion = ofensivo ? ['alta', 'media', 'alta'][bit(2) % 3] : PRESIONES[bit(2) % 3];
    const estilo = ESTILOS[bit(3) % 4];
    const marca = MARCAS[bit(4) % 2];
    return { formacion, actitud, presion, estilo, marca };
}

const TACTICA_LABEL = {
    formacion: 'Formación', actitud: 'Actitud', presion: 'Presión', estilo: 'Estilo de ataque', marca: 'Marca',
    '5-4-1': '5-4-1', '4-4-2': '4-4-2', '4-3-3': '4-3-3', '3-4-3': '3-4-3',
    defensiva: 'Defensiva', equilibrada: 'Equilibrada', ofensiva: 'Ofensiva', todo_o_nada: 'A todo o nada',
    repliegue: 'Repliegue', media: 'Media', alta: 'Presión alta',
    posesion: 'Posesión', directo: 'Juego directo', bandas: 'Por las bandas', contra: 'Contraataque',
    zona: 'En zona', hombre: 'Al hombre',
};

// Una "pista" de scouting del rival (no la pizarra completa): revela determinísticamente un eje.
function scoutingHint(rivTac, key) {
    const t = normTacticas(rivTac);
    const which = hashStr('hint:' + key) % 3;
    const DEFAULTS = {
        defensiva: '🕵️ Se van a meter atrás.', equilibrada: '🕵️ Van a jugar parejo, sin arriesgar.', ofensiva: '🕵️ Te van a salir a buscar.', todo_o_nada: '🕵️ Van a ir con todo al ataque.',
        repliegue: '🕵️ Te esperan replegados.', media: '🕵️ Presionan en su mitad.', alta: '🕵️ Vienen a presionarte arriba.',
        posesion: '🕵️ Les gusta tener la pelota.', directo: '🕵️ Juegan directo y al vacío.', bandas: '🕵️ Atacan mucho por las bandas.', contra: '🕵️ Esperan para salir de contra.',
    };
    const eje = which === 0 ? t.actitud : which === 1 ? t.presion : t.estilo;
    return i18n.t(`scouting.${eje}`, { defaultValue: DEFAULTS[eje] });
}

// Feedback post-partido según el acierto táctico y el resultado.
function tacticaFeedback(acierto, coherencia, gf, gc) {
    const gano = gf > gc, empato = gf === gc;
    const DEFAULTS = {
        messyWin: '🤔 Esquema algo descosido, pero lo sacaste adelante.',
        messyLose: '🤯 Tu planteo fue contradictorio y se notó en la cancha.',
        sharpWin: '🧠 Leíste perfecto al rival: tu planteo los rompió.',
        sharpLose: '🧠 Planteo acertado, te faltó eficacia arriba.',
        outreadWin: '😮‍💨 El rival te ganó la pizarra, pero zafaste.',
        outreadLose: '❌ Te leyeron el planteo y te pasaron por encima.',
        neatWin: '✅ Planteo prolijo y a ganar.',
        neatDraw: '➖ Planteo parejo, repartieron puntos.',
        neatLose: '🔻 Planteo correcto, no se te dio.',
    };
    let key;
    if (coherencia < 0.7) {
        key = gano ? 'messyWin' : 'messyLose';
    } else if (acierto >= 0.45) {
        key = gano ? 'sharpWin' : 'sharpLose';
    } else if (acierto <= -0.45) {
        key = gano ? 'outreadWin' : 'outreadLose';
    } else {
        key = gano ? 'neatWin' : empato ? 'neatDraw' : 'neatLose';
    }
    return i18n.t(`tacticaFeedback.${key}`, { defaultValue: DEFAULTS[key] });
}

// Minutos jugados según tu rating relativo al nivel esperado del club (estrellas).
function computeMinutes(player, ownClub) {
    const expectedRating = 40 + (ownClub.estrellas || 1) * 10;
    const gap = player.rating - expectedRating;
    const raw = 75 + gap * 1.5 + randomInt(-10, 10);
    return clamp(Math.round(raw / 5) * 5, 0, 90);
}

// ¿El equipo del jugador (ownGf goles) remontó un 0-3? Reconstruye un orden aleatorio de los
// goles del partido y devuelve true si en algún momento estuvo 3+ abajo y terminó ganando.
function detectRemontada03(ownGf, ownGc) {
    if (ownGf <= ownGc) return false;          // no ganó → no hay remontada
    if (ownGc < 3) return false;               // imposible haber estado 0-3 abajo
    const seq = [];
    for (let i = 0; i < ownGf; i++) seq.push(1);   // gol propio
    for (let i = 0; i < ownGc; i++) seq.push(-1);  // gol rival
    for (let i = seq.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [seq[i], seq[j]] = [seq[j], seq[i]];
    }
    let diff = 0, minDiff = 0;
    for (const g of seq) { diff += g; if (diff < minDiff) minDiff = diff; }
    return minDiff <= -3;
}

// homeClub/awayClub: { tm_id, nombre, estrellas }
// player: { rating, posicion, tacticas, isHome } presente solo si el club_actual juega este partido.
function simulateMatch(homeClub, awayClub, player = null) {
    const strengthDiff = (homeClub.estrellas || 1) - (awayClub.estrellas || 1);

    // Coeficiente de jerarquía: cuánto se traduce la diferencia de estrellas en goles. Se bajó
    // de 0.25 a 0.20 para comprimir un poco la tabla: el equipo más fuerte sigue siendo favorito
    // claro, pero ya no es campeón cantado todas las temporadas (deja más margen a sorpresas y
    // a que el torneo se pelee), sin por eso volver competitivos a los equipos del fondo.
    let lambdaHome = 1.4 + strengthDiff * 0.20 + 0.3;
    let lambdaAway = 1.1 - strengthDiff * 0.20;

    let minutosJugador = 0;
    let varianza = 1;
    let planDiff = 0;
    let indivMods = { gol: 1, amarilla: 1, roja: 1 }; // mods de aporte individual (plan o pizarra)
    let tacEval = null;                                // resultado de evaluarTactica (si usás pizarra)

    if (player) {
        const ownClub = player.isHome ? homeClub : awayClub;
        const rivalClub = player.isHome ? awayClub : homeClub;

        minutosJugador = computeMinutes(player, ownClub);
        const factorMinutos = minutosJugador / 90;

        // Aporte individual del jugador según su posición (la media ya refleja sus atributos):
        // los atacantes suman al ataque propio, los defensores le restan al ataque rival, los
        // mediocampistas un poco de cada. Atenuado a propósito: sos 1 de 11, un crack solo no
        // hace campeón a un equipo flojo (pero ayuda).
        const playerBonus = (player.rating - 60) / 200 * factorMinutos;
        const cat = categoriaPosicion(player.posicion);
        let ataqueAporte = 0, defensaAporte = 0;
        if (cat === 'atacante') ataqueAporte = playerBonus * 1.2;
        else if (cat === 'mediocampista') { ataqueAporte = playerBonus * 0.7; defensaAporte = playerBonus * 0.5; }
        else { defensaAporte = playerBonus * 1.2; }

        if (player.isHome) {
            lambdaHome += ataqueAporte;
            lambdaAway -= defensaAporte;
        } else {
            lambdaAway += ataqueAporte;
            lambdaHome -= defensaAporte;
        }

        planDiff = (ownClub.estrellas || 1) - (rivalClub.estrellas || 1);

        if (player.tacticas) {
            // Pizarra táctica (5 ejes): tu planteo vs el del rival. Acá está la "intervención" del
            // usuario como DT — mueve el esperado de goles de todo el equipo según el cruce de esquemas.
            tacEval = evaluarTactica(player.tacticas, player.rivalTacticas, planDiff);
            if (player.isHome) { lambdaHome *= tacEval.ownMul; lambdaAway *= tacEval.rivMul; }
            else { lambdaAway *= tacEval.ownMul; lambdaHome *= tacEval.rivMul; }
            varianza = tacEval.varianza;
            indivMods = { gol: tacEval.gol, amarilla: tacEval.amarilla, roja: tacEval.roja };
        } else {
            // Compatibilidad: plan de partido simple (carreras sin pizarra cargada).
            const pm = planMods(player.mentalidad);
            const acierto = planMatchup(player.mentalidad, planDiff);
            const ownMul = pm.own * (1 + 0.12 * acierto);
            const rivMul = pm.riv * (1 - 0.10 * acierto);
            if (player.isHome) { lambdaHome *= ownMul; lambdaAway *= rivMul; }
            else { lambdaAway *= ownMul; lambdaHome *= rivMul; }
            varianza = pm.var;
            indivMods = { gol: pm.gol, amarilla: pm.amarilla, roja: pm.roja };
        }
    }

    // Factor de "forma del día": cada equipo tiene un día mejor o peor de forma aleatoria e
    // independiente. Sube la varianza partido a partido → hay más sorpresas (el favorito no
    // gana siempre) y los torneos dejan de ser un trámite cantado para el equipo más fuerte,
    // sin alterar la jerarquía de fondo (en promedio el factor es 1). El plan "posesión" reduce
    // esa varianza (menos sorpresas) y la presión la aumenta.
    const spread = 0.26 * varianza;
    lambdaHome *= (1 - spread) + Math.random() * 2 * spread;
    lambdaAway *= (1 - spread) + Math.random() * 2 * spread;

    lambdaHome = clamp(lambdaHome, 0.2, 4.5);
    lambdaAway = clamp(lambdaAway, 0.2, 4.5);

    const gh = poissonSample(lambdaHome);
    const ga = poissonSample(lambdaAway);

    let golesJugador = 0;
    let asistenciasJugador = 0;
    let amarilla = false;
    let roja = false;

    if (player && minutosJugador > 0) {
        const rivalClub = player.isHome ? awayClub : homeClub;
        const golesPropios = player.isHome ? gh : ga;
        const factorMinutos = minutosJugador / 90;

        const expectedRatingRival = 40 + (rivalClub.estrellas || 1) * 10;
        const ratingVsRival = clamp((player.rating - expectedRatingRival) / 100, -0.3, 0.3);

        const probs = PARTICIPACION[player.posicion] || PARTICIPACION['Mediocampista Ofensivo'];
        const probGol = clamp(probs.gol * factorMinutos * (1 + ratingVsRival) * indivMods.gol, 0, 1);
        const probAsistencia = clamp(probs.asistencia * factorMinutos * (1 + ratingVsRival), 0, 1);

        for (let i = 0; i < golesPropios; i++) {
            const roll = Math.random();
            if (roll < probGol) {
                golesJugador++;
            } else if (roll < probGol + probAsistencia) {
                asistenciasJugador++;
            }
        }

        const probAmarilla = (categoriaPosicion(player.posicion) === 'defensivo' ? 0.18 : 0.10) * factorMinutos * indivMods.amarilla;
        const probRoja = 0.02 * factorMinutos * indivMods.roja;
        amarilla = Math.random() < probAmarilla;
        roja = Math.random() < probRoja;
    }

    // Feedback post-partido: si usaste pizarra, según el acierto táctico; si no, según el plan.
    let planFb = null;
    let remontada03 = false;
    if (player) {
        const ownGf = player.isHome ? gh : ga;
        const ownGc = player.isHome ? ga : gh;
        planFb = tacEval
            ? tacticaFeedback(tacEval.acierto, tacEval.coherencia, ownGf, ownGc)
            : planFeedback(player.mentalidad, planDiff, ownGf, ownGc);
        // ¿Remontada desde 0-3? El motor solo da el resultado final, así que reconstruimos un
        // orden plausible de los goles (mezclados al azar) y vemos si el equipo del jugador
        // estuvo en algún momento 3+ goles abajo y aun así terminó ganando.
        remontada03 = detectRemontada03(ownGf, ownGc);
    }

    return { gh, ga, minutosJugador, golesJugador, asistenciasJugador, amarilla, roja, planFeedback: planFb, remontada03 };
}

// Simula la prórroga (2x15, 30') de un partido de mata-mata que llegó empatado a los 90'. Mismo
// modelo de lambda por estrellas que simulateMatch pero escalado a 30' (1/3 de un partido) y sin
// pizarra táctica completa (ya se jugó con ella en los 90' regulares).
function simulateExtraTime(homeClub, awayClub, player = null) {
    const strengthDiff = (homeClub.estrellas || 1) - (awayClub.estrellas || 1);
    const factorTiempo = 30 / 90;
    let lambdaHome = (1.4 + strengthDiff * 0.20 + 0.3) * factorTiempo;
    let lambdaAway = (1.1 - strengthDiff * 0.20) * factorTiempo;

    let golesJugador = 0, asistenciasJugador = 0, amarilla = false, roja = false;

    if (player) {
        const rivalClub = player.isHome ? awayClub : homeClub;
        const playerBonus = (player.rating - 60) / 200 * factorTiempo;
        const cat = categoriaPosicion(player.posicion);
        let ataqueAporte = 0, defensaAporte = 0;
        if (cat === 'atacante') ataqueAporte = playerBonus * 1.2;
        else if (cat === 'mediocampista') { ataqueAporte = playerBonus * 0.7; defensaAporte = playerBonus * 0.5; }
        else { defensaAporte = playerBonus * 1.2; }
        if (player.isHome) { lambdaHome += ataqueAporte; lambdaAway -= defensaAporte; }
        else { lambdaAway += ataqueAporte; lambdaHome -= defensaAporte; }

        lambdaHome = clamp(lambdaHome, 0.05, 2);
        lambdaAway = clamp(lambdaAway, 0.05, 2);

        const gh = poissonSample(lambdaHome);
        const ga = poissonSample(lambdaAway);

        const golesPropios = player.isHome ? gh : ga;
        const expectedRatingRival = 40 + (rivalClub.estrellas || 1) * 10;
        const ratingVsRival = clamp((player.rating - expectedRatingRival) / 100, -0.3, 0.3);
        const probs = PARTICIPACION[player.posicion] || PARTICIPACION['Mediocampista Ofensivo'];
        const probGol = clamp(probs.gol * factorTiempo * (1 + ratingVsRival), 0, 1);
        const probAsistencia = clamp(probs.asistencia * factorTiempo * (1 + ratingVsRival), 0, 1);
        for (let i = 0; i < golesPropios; i++) {
            const roll = Math.random();
            if (roll < probGol) golesJugador++;
            else if (roll < probGol + probAsistencia) asistenciasJugador++;
        }
        const probAmarilla = (cat === 'defensivo' ? 0.18 : 0.10) * factorTiempo;
        const probRoja = 0.02 * factorTiempo;
        amarilla = Math.random() < probAmarilla;
        roja = Math.random() < probRoja;

        return { gh, ga, minutosJugador: 30, golesJugador, asistenciasJugador, amarilla, roja };
    }

    lambdaHome = clamp(lambdaHome, 0.05, 2);
    lambdaAway = clamp(lambdaAway, 0.05, 2);
    const gh = poissonSample(lambdaHome);
    const ga = poissonSample(lambdaAway);
    return { gh, ga, minutosJugador: 0, golesJugador, asistenciasJugador, amarilla, roja };
}

// Simula una tanda de penales entre dos equipos (A patea primero). Devuelve la tanda
// completa (penal por penal) y el ganador. La conversión base ronda el 72% con una leve
// ventaja para el equipo de más estrellas, así que la definición es pareja (~50/50 con un
// pequeño sesgo) y no un resultado cantado: ya no "perdés siempre".
function simulatePenaltyShootout(estrellasA = 3, estrellasB = 3) {
    const pA = clamp(0.72 + (estrellasA - estrellasB) * 0.03, 0.55, 0.9);
    const pB = clamp(0.72 + (estrellasB - estrellasA) * 0.03, 0.55, 0.9);
    const tanda = [];
    let a = 0, b = 0, ka = 0, kb = 0;
    const N = 5;

    // ¿Ya está decidido en la fase regular (uno no puede ser alcanzado)?
    const decidido = () => (a > b + (N - kb)) || (b > a + (N - ka));

    // Fase regular: hasta 5 penales cada uno, alternando A y B.
    while ((ka < N || kb < N) && !decidido()) {
        if (ka <= kb && ka < N) {
            const conv = Math.random() < pA; if (conv) a++; ka++;
            tanda.push({ equipo: 'a', convertido: conv });
        } else if (kb < N) {
            const conv = Math.random() < pB; if (conv) b++; kb++;
            tanda.push({ equipo: 'b', convertido: conv });
        } else break;
    }

    // Muerte súbita: pares completos hasta que haya diferencia.
    let guard = 0;
    while (a === b && guard++ < 50) {
        const ca = Math.random() < pA; if (ca) a++; ka++;
        tanda.push({ equipo: 'a', convertido: ca, muerte_subita: true });
        const cb = Math.random() < pB; if (cb) b++; kb++;
        tanda.push({ equipo: 'b', convertido: cb, muerte_subita: true });
    }

    return { ganador: a > b ? 'a' : 'b', golesA: a, golesB: b, tanda };
}

export {
    poissonSample, simulateMatch, simulateExtraTime, simulatePenaltyShootout, computeMinutes, categoriaPosicion, PARTICIPACION,
    PLANES, planMatchup, planFeedback, normPlan,
    FORMACIONES, ACTITUDES, PRESIONES, ESTILOS, MARCAS, TACTICA_LABEL,
    defaultTacticas, normTacticas, evaluarTactica, rivalTacticas, scoutingHint, tacticaFeedback, tacticaScalars,
};